import React, {
  useEffect,
  useState,
} from 'react';
import {
  useHistory,
} from 'react-router';
import {
  useObserver,
} from 'mobx-react';
import {
  RequestStatus,
  stores,
} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  Pagination,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
} from '../../constants/pagination';
import {
  ReleaseNotesDTO,
} from './DTOs/releaseNotesDTO';

const ReleasesNotesTableScreen: React.FC = () => {
  const [pagination, setPagination] = useState<Pagination>({
    pageNumber: DEFAULT_PAGE_NUMBER,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const [totalNumberOfPages, setTotalNumberOfPages] = useState(1);
  const history = useHistory();

  useEffect(() => {
    (async function () {
      await stores.releaseNotesStore.getPaginatedReleasesNotesList(pagination.pageNumber, pagination.pageSize);
      setTotalNumberOfPages(Math.ceil(
        stores.releaseNotesStore.totalNumberOfReleaseNotes / DEFAULT_PAGE_SIZE,
      ));
    }());
  }, []);

  useEffect(() => {
    stores.releaseNotesStore.getPaginatedReleasesNotesList(pagination.pageNumber, pagination.pageSize);
  }, [pagination]);

  const tableHeaders = [
    {
      title: 'Title',
    },
    {
      title: 'App Version',
    },
    {
      title: 'Status',
    },
  ];

  const handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentNotes = stores.releaseNotesStore.releasesNotesList.find((a, i) => i === index)!;

    const updatedStatusNotes: ReleaseNotesDTO = {
      ...currentNotes,
      isActive: value,
    };

    stores.releaseNotesStore.updateReleaseNotesById(currentNotes.releaseNotesId, updatedStatusNotes, undefined, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  const handleEditButtonClicked = (index: number) => {
    history.push(`/release-notes/${stores.releaseNotesStore.releasesNotesList[index].releaseNotesId}/edit`);
  };

  const cellTypes: TableCellTypes[] = [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Text',
      key: 'appVersion',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('FormActiveLabel', {
      }),
      inactiveLabel: translate('FormNotActiveLabel', {
      }),
      onChange: handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: handleEditButtonClicked,
    },
  ];

  const getTableData = () => stores.releaseNotesStore.releasesNotesList.map(
    (releaseNote: ReleaseNotesDTO) => ({
      title: releaseNote.title,
      appVersion: releaseNote.appVersion,
      isActive: releaseNote.isActive,
      edit: translate('editButton', {
      }),
    }),
  );

  const createAddButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: (): void => {
      history.push('/release-notes/new');
    },
  });

  const leftArrowClicked = () => {
    setPagination({
      ...pagination,
      pageNumber: pagination.pageNumber - 1,
    });
  };

  const rightArrowClicked = () => {
    setPagination({
      ...pagination,
      pageNumber: pagination.pageNumber + 1,
    });
  };

  return useObserver(
    () => (
      <GeneralTableComponent
        title={translate('releaseNotesTableTitle', {
        })}
        emptyMessage={translate('releaseNotesEmptyTableMessage', {
        })}
        tableHeader={tableHeaders}
        tableData={getTableData()}
        tableCellTypes={cellTypes}
        addButton={createAddButton()}
        loading={stores.releaseNotesStore.getReleasesNotesListRequestStatus === RequestStatus.LOADING}
        hadPagination
        paginationAction={{
          handleClickLeftArrow: leftArrowClicked,
          handleClickRightArrow: rightArrowClicked,
          pageNumber: pagination.pageNumber,
          totalNumberOfPages,
        }}
        loadingStatus={[
          stores.releaseNotesStore.getReleasesNotesListRequestStatus,
        ]}
      />
    ),
  );
};

export default ReleasesNotesTableScreen;
